import { render, staticRenderFns } from "./TextDisplayWithCopy.vue?vue&type=template&id=3ef0df6e&"
import script from "./TextDisplayWithCopy.vue?vue&type=script&lang=ts&"
export * from "./TextDisplayWithCopy.vue?vue&type=script&lang=ts&"
import style0 from "./TextDisplayWithCopy.vue?vue&type=style&index=0&id=3ef0df6e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports